function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9224 15.4804C19.5831 15.4804 18.2873 15.2627 17.0786 14.8707C16.8893 14.8065 16.6857 14.797 16.4911 14.8432C16.2966 14.8894 16.1191 14.9895 15.9788 15.132L14.2693 17.2771C11.1877 15.8071 8.30217 13.0304 6.76684 9.84L8.89017 8.03244C9.18417 7.72756 9.27128 7.30289 9.1515 6.92178C8.74861 5.71311 8.54172 4.41733 8.54172 3.078C8.54172 2.49 8.05172 2 7.46372 2H3.69617C3.10817 2 2.40039 2.26133 2.40039 3.078C2.40039 6.17137 3.18749 9.10487 4.56925 11.687C6.35947 15.0325 9.14791 17.7881 12.5161 19.5376C15.0495 20.8534 17.911 21.6 20.9224 21.6C21.6955 21.6 22.0004 20.914 22.0004 20.3151V16.5584C22.0004 15.9704 21.5104 15.4804 20.9224 15.4804Z",
  fill: "#C9107B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0782 14.8706C18.2868 15.2626 19.5826 15.4804 20.9219 15.4804C21.5099 15.4804 21.9999 15.9704 21.9999 16.5584V20.3151C21.9999 20.914 21.6951 21.6 20.9219 21.6C17.9106 21.6 15.0491 20.8534 12.5156 19.5375L14.2688 17.2771L15.9784 15.132C16.1186 14.9895 16.2962 14.8894 16.4907 14.8432C16.6852 14.7969 16.8888 14.8065 17.0782 14.8706Z",
  fill: "#D92B90"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.89017 8.03244L6.76684 9.84L4.56925 11.687C3.18749 9.10487 2.40039 6.17137 2.40039 3.078C2.40039 2.26133 3.10817 2 3.69617 2H7.46372C8.05172 2 8.54172 2.49 8.54172 3.078C8.54172 4.41733 8.74861 5.71311 9.1515 6.92178C9.27128 7.30289 9.18417 7.72756 8.89017 8.03244Z",
  fill: "#D92B90"
});
function SvgIcBaselineCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineCall);
export default __webpack_public_path__ + "static/media/ic_baseline-call.7b7dda1e6650704f7137cea05dbf2457.svg";
export { ForwardRef as ReactComponent };